export const environment = {
  staging: false,
  production: false,
  netevia:true,
  hmr: false
};
